import { isPlatformBrowser, NgClass } from '@angular/common';
import {
  Component,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  DOCUMENT,
  inject,
  ModelSignal,
  model,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FacultyI } from '../../interfaces/faculty.interface';
import { SIDE_MENU_ITEMS } from './constants/side-menu.constant';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';

@Component({
  selector: 'app-faculties-details-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './faculties-details-side-menu.component.html',
  styleUrl: './faculties-details-side-menu.component.scss',
})
export class FacultiesDetailsSideMenuComponent implements OnInit {
  private readonly router = inject(Router);
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object
  ) {}

  selectedFaculty: ModelSignal<FacultyI | null> = model<FacultyI | null>(null);

  sideMenuItems = SIDE_MENU_ITEMS;
  isSideMenuOpen = false;

  ngOnInit(): void {
    this.initScreenType();
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url ===
      '/' + sideMenuItem.route(this.selectedFaculty()?._id ?? '')
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    if (sideMenuItem.alt === 'Home') {
      return this.router.url?.trim() === '' || this.router.url === 'home';
    } else {
      return (
        this.router.url ===
        '/' + sideMenuItem.route(this.selectedFaculty()?._id ?? '')
      );
    }
  }

  @HostListener('window:resize')
  onResize() {
    this.isSideMenuOpen = window.innerWidth <= 700 && window.innerWidth >= 500;
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen =
        this.document.defaultView!.innerWidth <= 700 &&
        this.document.defaultView!.innerWidth >= 500;
    }
  }
}
